export default "__VITE_ASSET__DoBlpIEd__"